<template>
    <div class="video-modal mt-0 wallet-vidio-wrapper" v-for="(video, videoKey) in filteredVideos" :key="videoKey">
        <div class="container">
            <div class="video-modal-contain">
                <div class="thm-heading">
                    <h3>
                        {{
                            $route.name === 'wallet-deposit'
                                ? $t('how-to-deposit', 'How to Deposit') + ' (' + videoKey + ')'
                                : $t('how-to-withdraw', 'How to Withdraw') + ' (' + videoKey + ')'
                        }}
                    </h3>
                </div>

                <div class="video-sec">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe :src="video" :title="videoKey" frameborder="0"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WalletInstructionVideos",

    inject: ['walletConfig'],

    computed: {
        filteredVideos() {
            const videos =
                this.$route.name == 'wallet-deposit'
                    ? this.walletConfig.deposit_video
                    : this.walletConfig.withdrawal_video

            return Object.fromEntries(
                Object.entries(videos || {}).filter(
                    ([_, video]) => video && video.trim()
                )
            )
        }
    }
}
</script>